import React from 'react';
import ExclamationBlue from "../../../../picture/exclamation-blue.svg";
import ExclamationRed from "../../../../picture/exclamation-red.svg";
import ExclamationYellow from "../../../../picture/exclamation-yellow.svg";
import Check from "../../../../picture/check-green.svg";
import './style/message.css';

const MessageIcon = {
    'info': ExclamationBlue,
    'success': Check,
    'warning': ExclamationYellow,
    'danger': ExclamationRed,
}

const MyLink = ({ href = null, label, ...rest }) => {
	const Component = href ? "a" : "div";
	return (
		<Component className="wz-message-link" href={href} {...rest}>
			{label}
		</Component>
	);
};

export default function Message({title, description, link, type}) {
    // info, success, warning, danger
    return (
        <div className={`wz-message wz-message-${type}`}>
            <div className='wz-message-icon'>
                <img alt='' src={MessageIcon[type]}/>
            </div>
            <div className={`${title ? 'wz-message-title-and-description' : 'wz-message-without-title'}`}>
                {title && <div className='wz-message-title'>{title}</div>}
                <div className='wz-message-description'>{description}</div>
                <div>
                    <MyLink {...link} />
                </div>
            </div>
        </div>
    )
}
